const PATH_FTP = "https://khaktus.fr/Cookyn/React"
//const API = "http://localhost:5000/api"
const API = "https://api.licences.3fts.fr/api"

// eslint-disable-next-line import/no-anonymous-default-export
export default {PATH_FTP, API}
